import { useContext } from 'react';
import {
    NullableTokenContextData,
    NullableTokensContext,
    TokensContext,
    TokensContextData
} from './context';

export function useTokens(): TokensContextData {
    const data = useContext<TokensContextData | undefined>(TokensContext);

    if (!data) {
        throw new Error(
            "Tokens unavailable. Are you sure you're using this in a nested component of an TokensProvider?"
        );
    }

    return data;
}

export function useNullableTokens(): NullableTokenContextData {
    const data = useContext<NullableTokenContextData | undefined>(
        NullableTokensContext
    );

    if (!data) {
        throw new Error(
            "Tokens unavailable. Are you sure you're using this in a nested component of an NullableTokensProvider?"
        );
    }

    return data;
}
